// src/stone/illustrations/StonjiPillarAppIllustration.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var StonjiPillarAppIllustration = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 32 32",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1D232A",
          d: "m29.254 7.37-1.052 4.338-.215.886-.114.472-4.044 16.682a2.945 2.945 0 0 1-3.556 2.168l-11.6-2.815a2.945 2.945 0 0 1-2.167-3.557L11.93 3.167a2.946 2.946 0 0 1 3.555-2.17l6.068 1.474 5.53 1.341a2.946 2.946 0 0 1 2.17 3.557"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#42EC9A",
          d: "m29.255 7.37-1.052 4.338-5.756-5.199-2.508-2.268c.3-.207.904-.897 1.615-1.771l5.53 1.341a2.95 2.95 0 0 1 2.17 3.559M27.989 12.594l-.114.472-4.978-4.452c-.087-.078-.058-.236.022-.306.096-.081.217-.057.305.023.55.494 1.105.988 1.656 1.482q1.55 1.39 3.109 2.781"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#00A868",
          d: "M16.651 31.038 4.912 28.19a2.947 2.947 0 0 1-2.167-3.559L8.17 2.252A2.945 2.945 0 0 1 11.727.084l11.74 2.849a2.947 2.947 0 0 1 2.166 3.559L20.208 28.87a2.947 2.947 0 0 1-3.557 2.168"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#42EC9A",
          d: "M23.345 7.214 9.87 3.944 5.036 23.88l13.477 3.27z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#FCFCFC",
          stroke: "#FCFCFC",
          d: "m5.64 23.512 4.597-18.966.798.194-4.597 18.965z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1D232A",
          d: "M17.11 4.12a.616.616 0 1 0 0-1.233.616.616 0 0 0 0 1.232M13.946 18.445a.193.193 0 0 0 .156.235 3.242 3.242 0 0 0 1.476-6.3.193.193 0 0 0-.244.141l-.277 1.182a.223.223 0 0 0 .143.258 1.622 1.622 0 0 1-.733 3.133.22.22 0 0 0-.243.168zM13.363 13.58a.203.203 0 0 0-.279-.066l-1.429.987a.407.407 0 0 0-.125.534l.843 1.52a.201.201 0 0 0 .368-.061l.647-2.76a.2.2 0 0 0-.025-.154"
        }
      )
    ]
  }
);
var StonjiPillarAppIllustration_default = StonjiPillarAppIllustration;

export {
  StonjiPillarAppIllustration_default
};
